import { render, staticRenderFns } from "./AppFooterRegistration.vue?vue&type=template&id=00bb5f3e&scoped=true&"
import script from "./AppFooterRegistration.vue?vue&type=script&lang=js&"
export * from "./AppFooterRegistration.vue?vue&type=script&lang=js&"
import style0 from "./AppFooterRegistration.vue?vue&type=style&index=0&id=00bb5f3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bb5f3e",
  null
  
)

export default component.exports